import { render, staticRenderFns } from "./BrandSafety.vue?vue&type=template&id=64d7cabf&scoped=true&"
import script from "./BrandSafety.vue?vue&type=script&lang=js&"
export * from "./BrandSafety.vue?vue&type=script&lang=js&"
import style0 from "./BrandSafety.vue?vue&type=style&index=0&id=64d7cabf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7cabf",
  null
  
)

export default component.exports